//	poly-server's two public reads, called through the page's own domain
//	(CloudFront passes /api/* to the server). Both respond with
//	{success, data}; anything else is an error here.
import {boardQuery} from './format.js';

const BASE = '/api/v2/game-session';

async function getJSON(url) {
	const res = await fetch(url, {headers: {Accept: 'application/json'}});
	let body = null;
	try {
		body = await res.json();
	} catch (err) {
		body = null;
	}
	if (!res.ok || !body || body.success !== true) {
		const reason = body?.error || `HTTP ${res.status}`;
		throw new Error(reason);
	}
	return body.data;
}

export function fetchGames() {
	return getJSON(`${BASE}/games`);
}

//	The places with a score on this game's board, for the filter dropdowns.
export function fetchLocations(gameVersionID) {
	return getJSON(`${BASE}/locations?gameVersionID=${encodeURIComponent(gameVersionID)}`);
}

export function fetchBoard(params) {
	return getJSON(`${BASE}/leaderboard?${boardQuery(params)}`);
}
